/**
 * Returns a list of the Farsi passive verbs.
 * @returns {Array} The list with passive verbs.
 */
export default [
	"آراسته",
	"آزرده",
	"آزموده",
	"آشفته",
	"آغشته",
	"آفریده",
	"آلوده",
	"آمده",
	"آورده",
	"آمیخته",
	"آورده",
	"آویخته",
	"اُفتاده",
	"اَفراشته",
	"اَفروخته",
	"اَفزوده",
	"اَفشانده",
	"اَنباشته",
	"اَنداخته",
	"اَندوخته",
	"اِنگاشته",
	"برانگیخته",
	"باریده",
	"بافته",
	"بخشوده",
	"بخشیده",
	"برده",
	"برگردانده",
	"برگزیده",
	"بسته",
	"بلعیده",
	"بوسیده",
	"بوییده",
	"پاشیده",
	"پخته",
	"پذیرفته",
	"پراکنده",
	"پرداخته",
	"پرستیده",
	"پرسیده",
	"پژمرده",
	"پسندیده",
	"پنداریده",
	"پوشیده",
	"پوشانده",
	"پیچیده",
	"پیوسته",
	"پیموده",
	"تافته",
	"تراشیده",
	"ترسانده",
	"ترکیده",
	"ترکانده",
	"تَکانده",
	"تنیده",
	"توانسته",
	"جوشانده",
	"جوشیده",
	"جَویده",
	"جوییده",
	"چاپیده",
	"چرخیده",
	"چسبانده",
	"چسبیده",
	"چشیده",
	"چیده",
	"خاسته",
	"خشکیده",
	"خراشیده",
	"خریده",
	"خوانده",
	"خورده",
	"داده",
	"دریده",
	"دزدیده",
	"دوخته",
	"دوشیده",
	"دیده",
	"رانده",
	"ربوده",
	"رسانده",
	"رسیده",
	"رشته",
	"رفته",
	"ریخته",
	"زاده",
	"زده",
	"زدوده",
	"ساخته",
	"سابیده",
	"ساییده",
	"ستانده",
	"ستوده",
	"سرشته",
	"سروده",
	"سوخته",
	"سوزانده",
	"شده",
	"شسته",
	"شکافته",
	"شکانده",
	"شکسته",
	"شکفته",
	"شکافیده",
	"شمرده",
	"شناسانده",
	"شنفته",
	"شنیده",
	"طلبیده",
	"فرساییده",
	"فرستاده",
	"فرسوده",
	"فرموده",
	"فروخته",
	"فریفته",
	"فشرده",
	"کاسته",
	"کاشته",
	"کشته",
	"کشیده",
	"گفته",
	"کوبیده",
	"گداخته",
	"گذاشته",
	"گردانده",
	"گرفته",
	"گزارده",
	"گَزیده",
	"گُسترانده",
	"گُسترده",
	"گسسته",
	"گسیخته",
	"گشته",
	"گشوده",
	"گفته",
	"گماشته",
	"مالیده",
	"نامیده",
	"نگاشته",
	"نواخته",
	"نوردیده",
	"نِوِشته",
	"نوشیده",
	"نهاده",
	"نهفته",
	"وابسته",
	"واگذاشته",
	"واگفته",
	"وانهاده",
	"انداخته",
	"افتاده",
	"ورانداخته",
	"ورزیده",
	"وزیده",
	"ویرایش شده",
	"یافته",
	"ستانده شده",
	"آغازشده",
	"آماده",
	"اَرزیده",
	"آمده",
	// Compound participles (used with prepositional verbs, auxiliary, or a compound verb. both verbs are in the participle form)
	"پذیرایی شده",
	"تولید شده",
	"استفاده شده",
	"آسفالت شده",
	"اخراج شده",
	"خلق شده",
	"خیس شده",
	"آماده شده",
	"باز شده",
	"بازپس گرفته شده",
	"بشمار آمده",
	"بررسی شده",
	"پاره شده",
	"پیدا شده",
	"زخم خورده",
	"انعام داده شده",
	"زخم شده",
	"ضایع شده",
	"شکست یافته",
	"شروع شده",
	"گول خورده",
	"دزدی رفته",
	"انجام گرفته",
	"فرمایش داده",
	"فرمایش شده",
	"به سر برده",
	"سر رفته",
	"سر آمده",
	"روشن شده",
	"راهنمایی شده",
	"تکان خورده",
	"زمین خورده",
	"دیده شده",
	"بر آمده",
	"تلفیق شده",
	"تخلیه شده",
	"توافق شده",
	"توجه شده",
	"توقف شده",
	"توقیف شده",
	"حمله شده",
	"خبردار شده",
	"گرفتار شده",
	"مسخره شده",
	"مقصر شناخته شده",
	"مضاعف شده",
	"ممکن شده",
	"نقشه کشیده",
	"آغازشدن",
	"آماده شدن",
	"ارزیابی شدن",
	"پذیرایی شدن",
	"تولید شدن",
	"استفاده شدن",
	"آسفالت شدن",
	"اخراج شدن",
	"خلق شدن",
	"خیس شدن",
	"آماده شدن",
	"باز کردن",
	"باز پس گرفتن",
	"بشمار آمدن",
	"بررسی شدن",
	"پاره شدن",
	"پیدا شدن",
	"زخم خوردن",
	"انعام گرفتن",
	"زخم شدن",
	"ضایع شدن",
	"شکست یافتن",
	"شروع شدن",
	"گول خوردن",
	"دزدی رفتن",
	"انجام گرفتن",
	"فرمایش دادن",
	"فرمایش شدن",
	"به سر بردن",
	"سر رفتن",
	"سر آمدن",
	"روشن شدن",
	"راهنمایی کردن",
	"تکان خوردن",
	"زمین خوردن",
	"دیده شدن",
	"بر آمدن",
	"تلفیق شدن",
	"تخلیه شدن",
	"توافق شدن",
	"توجه شدن",
	"توقف کردن",
	"توقیف شدن",
	"حمله شدن",
	"خبردار شدن",
	"گرفتار آمدن",
	"مسخره شدن",
	"مقصر شناخته شدن",
	"مضاعف کردن",
	"ممکن شدن",
	"نقشه کشیدن",
	"آغاز شده",
	"آماده شد",
	"ارزیابی شدم",
	"پذیرایی شدم",
	"تولید شد",
	"استفاده شد",
	"آسفالت شد",
	"اخراج شدم",
	"خلق شدم",
	"خیس شدم",
	"آماده شد",
	"باز شد",
	"باز پس گرفته شد",
	"بشمار آمد",
	"بررسی شد",
	"پاره شد",
	"پیدا شد",
	"زخم خورد",
	"انعام گرفتم",
	"زخم شد",
	"ضایع شد",
	"شکست یافتم",
	"شروع شد",
	"گول خوردم",
	"دزدی رفت",
	"انجام گرفت",
	"سر رفت",
	"سر آمد",
	"روشن شد",
	"راهنمایی شدم",
	"تکان خورد",
	"زمین خورد",
	"دیده شدم",
	"تلفیق شد",
	"تخلیه شد",
	"توافق شد",
	"توجه شد",
	"توقف کرد",
	"توقیف شدم",
	"حمله شد",
	"خبردار شدم",
	"گرفتار آمد",
	"مسخره شدم",
	"مقصر شناخته شدم",
	"مضاعف شد",
	"ممکن شد",
	"نقشه کشیده شد",
	"آغاز شده است",
	"آماده می‌شد",
	"ارزیابی شدی",
	"پذیرایی شدی",
	"تولید می‌شد",
	"استفاده می‌شد",
	"آسفالت می‌شد",
	"اخراج شدی",
	"خلق شدی",
	"خیس شدی",
	"آماده می‌شد",
	"باز شدند",
	"باز پس گرفته شد",
	"بشمار آمدند",
	"بررسی شدند",
	"پاره شدند",
	"پیدا شدند",
	"زخم خوردند",
	"انعام گرفتی",
	"زخم شدند",
	"ضایع شدند",
	"شکست یافتی",
	"شروع می‌شد",
	"گول خوردی",
	"دزدی رفته",
	"انجام گرفتند",
	"سر می‌رفت",
	"داشت سر می‌آمد",
	"روشن شدند",
	"راهنمایی شدی",
	"تکان خوردند",
	"زمین خواهد خورد",
	"دیده شدی",
	"تلفیق شدند",
	"تخلیه شدند",
	"توافق شده",
	"توجه می‌شد",
	"توقف کردند",
	"توقیف شدی",
	"حمله می‌شد",
	"خبردار شدی",
	"گرفتار آمده",
	"مسخره شدی",
	"مقصر شناخته شدی",
	"مضاعف شده",
	"ممکن شده",
	"نقشه کشیده شده است",
	"داشت آغاز می‌شد",
	"داشت آماده می‌شد",
	"ارزیابی شد",
	"پذیرایی شد",
	"داشت تولید می‌شد",
	"داشت استفاده می‌شد",
	"داشت آسفالت می‌شد",
	"اخراج شد",
	"خلق شد",
	"خیس شد",
	"آماده می‌شدند",
	"باز می‌شد",
	"داشت باز پس گرفته می‌شد",
	"بشمار می‌آمد",
	"بررسی می‌شد",
	"پاره می‌شد",
	"پیدا شده",
	"زخم خورده",
	"انعام گرفت",
	"زخم شده",
	"ضایع شده",
	"شکست یافت",
	"داشت شروع می‌شد",
	"گول خورد",
	"دزدی رفته است",
	"انجام می‌گرفت",
	"سر رفته",
	"سر آمده",
	"روشن می‌شد",
	"راهنمایی شد",
	"تکان می‌خورد",
	"دیده شد",
	"تلفیق می‌شد",
	"تخلیه می‌شد",
	"توافق شده است",
	"توجه شده",
	"توقف کرده",
	"توقیف شد",
	"داشت حمله می‌شد",
	"خبردار شد",
	"گرفتار آمده است",
	"مسخره شد",
	"مقصر شناخته شد",
	"مضاعف شده است",
	"ممکن شده است",
	"نقشه کشیده خواهد شد",
	"آغاز شده بود",
	"آماده شده",
	"ارزیابی شدیم",
	"پذیرایی شدیم",
	"تولید شده ",
	"استفاده شده",
	"آسفالت شده",
	"اخراج شدیم",
	"خلق شدیم",
	"خیس شدیم",
	"داشت آماده می‌شد",
	"باز می‌شدند",
	"داشتند باز پس گرفته می‌شدند",
	"بشمار می‌آمدند",
	"بررسی می‌شدند",
	"پاره می‌شدند",
	"پیدا شده است",
	"زخم خورده است",
	"انعام گرفتیم",
	"زخم شده است",
	"ضایع شده است",
	"شکست یافتیم",
	"شروع شده",
	"گول خوردیم",
	"دزدی رفته بود",
	"انجام می‌گرفتند",
	" سر رفته است",
	"سر آمده است",
	"روشن می‌شدند",
	"راهنمایی شدیم",
	"تکان می‌خوردند",
	"دیده شدیم",
	"تلفیق می‌شدند",
	"تخلیه می‌شدند",
	"توافق شده بود",
	"توجه شده است",
	"توقف کرده است",
	"توقیف شدیم",
	"حمله شده",
	"خبردار شدیم",
	"گرفتار آمده بود",
	"مسخره شدیم",
	"مقصر شناخته شدیم",
	"مضاعف شده بود",
	"ممکن شده بود",
	"آغاز شود",
	"آماده شده است",
	"ارزیابی شدید",
	"پذیرایی شدید",
	"تولید شده است",
	"استفاده شده است",
	"آسفالت شده است",
	"اخراج شدید",
	"خلق شدید",
	"خیس شدید",
	"داشتند آماده می‌شدند",
	"داشت باز می‌شد",
	"باز پس گرفته شده",
	"داشت بشمار می‌آمد",
	"داشت بررسی می‌شد",
	"پاره شده",
	"پیدا شده بود",
	"زخم خورده بود",
	"انعام گرفتید",
	"زخم شده‌اند",
	"ضایع شده بود",
	"شکست یافتید",
	"شروع شده است",
	"گول خوردید",
	"دزدی می‌رود",
	"داشت انجام می‌گرفت",
	"سر رفته بود",
	"سر آمده بود",
	"داشت روشن می‌شد",
	"راهنمایی شدید",
	"داشت تکان می‌خورد",
	"دیده شدید",
	"داشت تلفیق می‌شد",
	"داشت تخلیه می‌شد",
	"توافق شود",
	"توجه شده بود",
	"توقف کرده بود",
	"توقیف شدید",
	"حمله شده است",
	"خبردار شدید",
	"گرفتار خواهد آمد",
	"مسخره شدید",
	"مقصر شناخته شدید",
	"مضاعف شود",
	"ممکن شود",
	"آغاز می‌شود",
	"آماده شده بود",
	"ارزیابی شدند",
	"پذیرایی شدند",
	"تولید شده بود",
	"استفاده شده بود",
	"آسفالت شده بود",
	"اخراج شدند",
	"خلق شدند",
	"خیس شدند",
	"آماده شده",
	"داشتند باز می‌شدند",
	"باز پس گرفته شده است",
	"داشتند بشمار می‌آمدند",
	"داشتند بررسی می‌شدند",
	"پاره شده است",
	"پیدا شده بودند",
	"زخم خورده بودند",
	"انعام گرفتند",
	"زخم شده بود",
	"ضایع شده بودند",
	"شکست یافتند",
	"شروع شده‌اند",
	"گول خوردند",
	"دزدی رفته باشد",
	"داشتند انجام می‌گرفتند",
	"دارد سر می‌رود",
	"سر خواهد آمد",
	"داشتند روشن می‌شدند",
	"راهنمایی شدند",
	"داشتند تکان می‌خوردند",
	"دیده شدند",
	"داشتند تلفیق می‌شدند",
	"داشتند تخلیه می‌شدند",
	"توافق می‌شود",
	"توجه می‌شود",
	"توقف می‌کند",
	"توقیف شدند",
	"حمله شده بود",
	"خبردار شدند",
	"مسخره شدند",
	"مقصر شناخته شدند",
	"مضاعف می‌شود",
	"ممکن خواهد شد",

	"آراستن",
	"آزردن",
	"آزمودن",
	"آشفتن",
	"آغشتن",
	"آفریدن",
	"آلودن",
	"آمدن",
	"آمیختن",
	"آوردن",
	"آویختن",
	"اُفتادن",
	"اَفراشتن",
	"اَفروختن",
	"اَفزودن",
	"اَفشاندن",
	"اَنباشتن",
	"اَنداختن",
	"اَندوختن",
	"برانگیختن",
	"بافتن",
	"بخشودن",
	"بخشیدن",
	"بردن",
	"برگرداندن",
	"برگزیدن",
	"بستن",
	"بلعیدن",
	"بوسیدن",
	"بوییدن",
	"پاشیدن",
	"پختن",
	"پذیرفتن",
	"پراکندن",
	"پرداختن",
	"پرستیدن",
	"پرسیدن",
	"پژمردن",
	"پسندیدن",
	"پوشیدن",
	"پوشاندن",
	"پیچیدن",
	"پیوستن",
	"پیمودن",
	"تافتن",
	"تراشیدن",
	"ترساندن",
	"ترکیدن",
	"ترکاندن",
	"تَکاندن",
	"تنیدن",
	"توانستن",
	"جوشاندن",
	"جوشیدن",
	"جَویدن",
	"جوییدن",
	"چاپیدن",
	"چرخییدن",
	"چسباندن",
	"چسبیدن",
	"چشیدن",
	"چیدن",
	"خاستن",
	"خشکاندن",
	"خراشیدن",
	"خریدن",
	"خواندن",
	"خوردن",
	"دادن",
	"دریدن",
	"دزدیدن",
	"دوختن",
	"دوشیدن",
	"راندن",
	"ربودن",
	"رساندن",
	"رسیدن",
	"ریختن",
	"زادن",
	"زدن",
	"زدودن",
	"ساختن",
	"سابیدن",
	"ساییدن",
	"ستاندن",
	"ستودن",
	"سرشتن",
	"سرودن",
	"سوختن",
	"سوزاندن",
	"انجام شدن",
	"شستن",
	"شکافتن",
	"شکاندن",
	"شکستن",
	"شکُفتن",
	"شمردن",
	"شناساندن",
	"شِنُفتن",
	"شنیدن",
	"طلبیدن",
	"فرساییدن",
	"فرستادن",
	"فرسودن",
	"فرمودن",
	"فروختن",
	"فریفتن",
	"فِشُردن",
	"کاستن",
	"کاشتن",
	"کُشتن",
	"کشیدن",
	"کَفتن",
	"کوبیدن",
	"گُداختن",
	"گذاشتن",
	"گرداندن",
	"گرفتن",
	"گزاردن",
	"گَزیدن",
	"گُستراندن",
	"گُستَردن",
	"گُسستن",
	"گُسیختن",
	"گشودن",
	"گفتن",
	"گُماشتن",
	"مالیدن",
	"نامیدن",
	"نگاشتن",
	"نواختن",
	"نَوردیدن",
	"نِوِشتن",
	"نوشیدن",
	"نهادن",
	"نهفتن",
	"واگذاشتن",
	"وانهادن",
	"افتادن",
	"ورانداختن",
	"ورزیدن",
	"ویرایش کردن",
	"یافتن",
	"ستاندن",
	"آراسته شد",
	"آزرده شدم",
	"آزموده شدم",
	"آشفته شدم",
	"آغشته شد",
	"آفریده شد",
	"آلوده شد",
	"آمد",
	"آمیخته شد",
	"آورده شد",
	"آویخته شد",
	"افتاده شده",
	"افراشته شد",
	"افروخته شد",
	"افزوده شد",
	"افشانده شد",
	"انباشته شد",
	"انداخته شد",
	"اندوخته شد",
	"برانگیخته شد",
	"بافته شد",
	"بخشوده شد",
	"بخشیده شد",
	"برده شد",
	"برگردانده شد",
	"برگزیده شده",
	"بسته شد",
	"بلعیده شد",
	"بوسیده شدم",
	"بوییده شد",
	"پاشیده شد",
	"پخته شد",
	"پذیرفته شدم",
	"پراکنده شد",
	"پرداخته شد",
	"پرستیده شد",
	"پرسیده شد",
	"پژمرده شد",
	"پسندیده شد",
	"پوشیده شد",
	"پیچیده شد",
	"پیوسته شده",
	"پیموده شد",
	"تافته شد",
	"تراشیده شد",
	"ترسانده شدم",
	"ترکیده شد",
	"تکانده شد",
	"تنیده شد",
	"جوشانده شد",
	"جوشیده شد",
	"جویده شد",
	"جوییده شده",
	"چاپیده شدم",
	"چرخیده شد",
	"چسبانده شد",
	"چسبیده شد",
	"چشیده شد",
	"چیده شد",
	"خاسته شد",
	"خشکیده شد",
	"خراشیده شد",
	"خریده شد",
	"خوانده شد",
	"خورده شد",
	"داده شد",
	"دریده شد",
	"دزدیده شد",
	"دوخته شد",
	"دوشیده شد",
	"رانده شد",
	"ربوده شد",
	"رسانده شد",
	"رسیده شد",
	"ریخته شد",
	"زاده شد",
	"زده شد",
	"زدوده شد",
	"ساخته شد",
	"سابیده شد",
	"ستانده شد",
	"ستوده شد",
	"سرشته شد",
	"سروده می‌شود",
	"سوخته شد",
	"سوزانده شد",
	"انجام شد",
	"شسته شد",
	"شکافته شد",
	"شکانده شد",
	"شکسته شد",
	"شکفته شد",
	"شمرده شد",
	"شناسانده شد",
	"شنفته شد",
	"شنیده شد",
	"طلبیده شدم",
	"فرساییده شد",
	"فرستاده شد",
	"فرسوده شد",
	"فرموده شد",
	"فروخته شد",
	"فریفته شد",
	"فشرده شد",
	"کاسته شد",
	"کاشته شد",
	"کشته شد",
	"کشیده شد",
	"گفته شد",
	"کوبیده شد",
	"گداخته شده",
	"گذاشته شد",
	"گردانده شد",
	"گرفته شد",
	"گزارده شد",
	"گزیده شد",
	"گسترانده شد",
	"گسترده شد",
	"گسسته شد",
	"گسیخته شد",
	"گشوده شد",
	"گفته شد",
	"گماشته شده",
	"مالیده شد",
	"نامیده شد",
	"نگاشته شد",
	"نواخته شد",
	"نوردیده شد",
	"نوشته شد",
	"نوشیده شد",
	"نهاده شد",
	"نهفته شده",
	"واگذاشته شد",
	"وانهاده شد",
	"افتاده شد",
	"ورانداخته شد",
	"ورزیده شد",
	"ویرایش شد",
	"یافته شد",
	"ستانده شد",
	"آراسته شدند",
	"آزرده شدی",
	"آزموده شدی",
	"آشفته شدی",
	"آغشته شده",
	"آفریده شدیم",
	"آلوده شدند",
	"آمدند",
	"آمیخته شدند",
	"آورده شدند",
	"آویخته شدند",
	"افتاده شده است",
	"افراشته شدند",
	"داشت افروخته می‌شد",
	"افزوده شدند",
	"افشانده شدند",
	"انباشته شدند",
	"انداخته شدند",
	"اندوخته شدند",
	"برانگیخته می‌شد",
	"بافته شدند",
	"بخشوده شدند",
	"بخشیده شدند",
	"برده شدند",
	"برگردانده شدند",
	"برگزیده شده است",
	"بسته شدند",
	"بلعیده شدند",
	"بوسیده شد",
	"بوییده شده",
	"پاشیده شده",
	"پخته شدند",
	"پذیرفته شد",
	"پراکنده شدند",
	"پرداخته شده",
	"پرستیده می‌شود",
	"پرسیده شدند",
	"پژمرده شدند",
	"پسندیده شدند",
	"پوشیده شدند",
	"پیچیده شده",
	"پیوسته شده است",
	"پیموده شده",
	"تافته شدند",
	"تراشیده شدند",
	"ترسانده شد",
	"ترکیده شده",
	"تکانده شدند",
	"تنیده شده",
	"داشت جوشانده می‌شد",
	"داشت جوشیده می‌شد",
	"جویده شده",
	"جوییده شده است",
	"چاپیده شدی",
	"چرخیده شدند",
	"چسبانده شدند",
	"چسبیده شدند",
	"چشیده شدند",
	"چیده شدند",
	"خاسته شدند",
	"خشکیده شدند",
	"خراشیده شدند",
	"خریده شدند",
	"خوانده شدند",
	"خورده شدند",
	"داده شدند",
	"دریده شدند",
	"دزدیده شدند",
	"دوخته شدند",
	"دوشیده شدند",
	"رانده شدند",
	"ربوده شدند",
	"رسانده شده",
	"رسیده شده",
	"داشت ریخته می‌شد",
	"زاده شده",
	"داشت زده می‌شد",
	"زدوده شده",
	"ساخته شدند",
	"سابیده شدند",
	"ستانده شده",
	"ستوده می‌شد",
	"سرشته شده",
	"سروده شوده",
	"داشت سوخته می‌شد",
	"سوزانده شدند",
	"انجام شدند",
	"شسته شدند",
	"شکافته شدند",
	"شکانده شدند",
	"شکسته شدند",
	"شکفته شدند",
	"شمرده شدند",
	"شناسانده شدند",
	"شنفته می‌شد",
	"شنیده می‌شد",
	"طلبیده شدی",
	"فرساییده شدند",
	"فرستاده شدند",
	"فرسوده شدند",
	"فرموده شده",
	"فروخته شدند",
	"داشت فریفته می شد",
	"فشرده شده",
	"کاسته می‌شد",
	"کاشته شده",
	"کشته شدند",
	"کشیده شدند",
	"گفته شده",
	"داشت کوبیده می‌شد",
	"گداخته شده است",
	"داشت گذاشته می‌شد",
	"گردانده شده",
	"داشت گرفته می‌شد",
	"گزارده شده",
	"گزیده شدم",
	"گسترانده شده",
	"گسترده شده",
	"گسسته شده",
	"گسیخته شده",
	"داشت گشوده می‌شد",
	"داشت گفته می‌شد",
	"گماشته شده است",
	"مالیده شده",
	"نامیده شده",
	"داشت نگاشته می‌شد",
	"نواخته می‌شد",
	"نوردیده شده",
	"نوشته شدند",
	"نوشیده شده",
	"نهاده شده",
	"نهفته شده است",
	"واگذاشته شده",
	"وانهاده شده",
	"افتاده شدند",
	"ورانداخته شده",
	"ورزیده شده",
	"ویرایش شدند",
	"یافته شدند",
	"ستانده شده",
	"آراسته شده",
	"آزرده شد",
	"آزموده شد",
	"آشفته شد",
	" آغشته شده است",
	"آفریده شدند",
	"داشت آلوده می‌شد",
	"داشت می‌آمد",
	"آمیخته می‌شد",
	"آورده می‌شد",
	"آویخته شده",
	"افتاده شده بود",
	"افراشته شده",
	"افروخته شده",
	"داشت افزوده می‌شد",
	"افشانده شده",
	"داشت انباشته می‌شد",
	"انداخته می‌شد",
	"اندوخته می‌شد",
	"برانگیخته شده",
	"داشت بافته می‌شد",
	"بخشوده شده",
	"بخشیده شده",
	"داشت برده می‌شد",
	"برگردانده شده",
	"برگزیده شده بود",
	"بسته می‌شد",
	"بلعیده شده",
	"بوییده شده است",
	"پاشیده شده است",
	"پخته می‌شد",
	"پذیرفته شدند",
	"پراکنده می‌شد",
	"پرداخته شده است",
	"پرستیده خواهد شد",
	"داشت پرسیده می‌شد",
	"پژمرده می‌شد",
	"پسندیده شده",
	"داشت پوشیده می‌شد",
	"پیچیده شده است",
	"پیموده شده است",
	"تافته شده",
	"داشت تراشیده می‌شد",
	"ترسانده شدند",
	"ترکیده شده است",
	"تکانده شده",
	"تنیده شده است",
	"جوشانده شده",
	"جوشیده شده",
	"جویده شده است",
	"چاپیده شد",
	"چرخیده شده",
	"داشت چسبانده می‌شد",
	"چسبیده شده",
	"چشیده شده",
	"داشت چیده می‌شد",
	"خاسته شده",
	"خشکیده شده",
	"خراشیده شده",
	"خریده شده",
	"داشت خوانده می‌شد",
	"خورده می‌شد",
	"داده شده",
	"دریده شده",
	"داشت دزدیده می‌شد",
	"داشت دوخته می‌شد",
	"داشت دوشیده می‌شد",
	"رانده شده",
	"ربوده شده",
	"رسانده شده است",
	"رسیده شده است",
	"ریخته شده",
	"زاده شده است",
	"زده شده",
	"زدوده شده است",
	"داشت ساخته می‌شد",
	"داشت سابیده می‌شد",
	"ستانده شده است",
	"ستوده شده",
	"سرشته شده است",
	"سروده شوده است",
	"داشتند سوخته می‌شدند",
	"داشت سوزانده می‌شد",
	"انجام می‌شد",
	"شسته می‌شد",
	"داشت شکافته می‌شد",
	"داشت شکانده می‌شد",
	"شکسته می‌شد",
	"شکفته می‌شد",
	"شمرده شده",
	"شناسانده شده",
	"داشت شنفته می‌شد",
	"داشت شنیده می‌شد",
	"طلبیده شد",
	"فرساییده شده",
	"فرستاده شده",
	"داشت فرسوده می‌شد",
	"فرموده شده است",
	"فروخته می‌شد",
	"فریفته شده",
	"فشرده شده است",
	"داشت کاسته می‌شد",
	"کاشته شده است",
	"کشته شده",
	"داشت کشیده می‌شد",
	"گفته شده است",
	"کوبیده می‌شود",
	"گداخته شد",
	"گذاشته شده",
	"گردانده شده است",
	"گرفته شده",
	"گزارده شده است",
	"گزیده شدی",
	"گسترانده شده است",
	"گسترده شده است",
	"گسسته شده است",
	"گسیخته شده است",
	"گشوده شده",
	"گفته شده",
	"گماشته خواهد شد",
	"مالیده شده است",
	"نامیده شده است",
	"نگاشته شده",
	"داشت نواخته می‌شد",
	"نوردیده شده است",
	"داشت نوشته می‌شد",
	"نوشیده شده است",
	"نهاده شده است",
	"نهفته شده بود",
	"واگذاشته شده است",
	"وانهاده شده است",
	"افتاده شده",
	"ورانداخته شده است",
	"ورزیده شده است",
	"ویرایش شده",
	"یافته شده",
	"ستانده شده",
	"آراسته شده است",
	"آزرده شدیم",
	"آزموده شدیم",
	"آشفته شدیم",
	"آغشته شده بود",
	"آفریده شده‌ام",
	"داشتند آلوده می‌شدند",
	"آمیخته می‌شدند",
	"آورده می‌شدند",
	"آویخته شده است",
	"افتاده شده بودند",
	"افراشته شده است",
	"افروخته شده است",
	"داشتند افزوده می‌شدند",
	"افشانده شده است",
	"داشتند انباشته می‌شدند",
	"انداخته می‌شدند",
	"اندوخته می‌شدند",
	"برانگیخته شده است",
	"داشتند بافته می‌شدند",
	"بخشوده شده است",
	"بخشیده شده است",
	"داشتند برده می‌شدند",
	"برگردانده شده است",
	"برگزیده خواهد شد",
	"بسته می‌شدند",
	"بلعیده شده است",
	"پاشیده شده بود",
	"پخته می‌شدند",
	"پذیرفته شده‌ام",
	"پراکنده می‌شدند",
	"پرداخته شده بود",
	"پرستیده بشود",
	"پرسیده شده",
	"پژمرده می‌شدند",
	"پسندیده شده است",
	"داشتند پوشیده می‌شدند",
	"پیچیده شده بود",
	"پیموده شده بود",
	"تافته شده است",
	"داشتند تراشیده می‌شدند",
	"ترسانده شده",
	"تکانده شده است",
	"تنیده شده بود",
	"جوشانده شده است",
	"جوشیده شده است",
	"جویده بشود",
	"چاپیده شدیم",
	"چرخیده شده است",
	"چسبانده شده",
	"چسبیده شده است",
	"چشیده شده است",
	"داشتند چیده می‌شدند",
	"خاسته شده است",
	"خشکیده شده است",
	"خراشیده شده است",
	"خریده شده است",
	"داشتند خوانده می‌شدند",
	"خورده می‌شدند",
	"داده شده است",
	"دریده شده است",
	"دزدیده شده",
	"داشتند دوخته می‌شدند",
	"داشتند دوشیده می‌شدند",
	"رانده شده است",
	"ربوده شده است",
	"رسانده شده بود",
	"رسیده شده بود",
	"ریخته شده است",
	"زاده شده بود",
	"زده شده است",
	"زدوده شده بود",
	"داشتند ساخته می‌شدند",
	"داشتند سابیده می‌شدند",
	"ستانده شده بود",
	"ستوده شده است",
	"سروده شوده بود",
	"سوخته شده",
	"داشتند سوزانده می‌شدند",
	"انجام می‌شدند",
	"شسته می‌شدند",
	"داشتند شکافته می‌شدند",
	"داشتند شکانده می‌شدند",
	"شکسته می‌شدند",
	"شکفته می‌شدند",
	"شمرده شده است",
	"شناسانده شده است",
	"شنفته شده",
	"شنیده شده",
	"طلبیده شدیم",
	"فرساییده شده است",
	"فرستاده شده است",
	"فرسوده شده",
	"فروخته می‌شدند",
	"فریفته شده است",
	"فشرده شده بود",
	"کاسته شده",
	"کاشته شده بود",
	"کشته شده است",
	"کشیده شده",
	"گفته شده بود",
	"گذاشته شده است",
	"گردانده بشود",
	"گرفته شده است",
	"گزارده شده باشد",
	"گزیده شد",
	"گسترانده شده بود",
	"گسترده شده بود",
	"گسسته شده بود",
	"گشوده شده است",
	"گفته شده است",
	"مالیده می‌شود",
	"نگاشته شده است",
	"نواخته شده",
	"دارد نوردیده می‌شود",
	"داشتند نوشته می‌شدند",
	"نوشیده شده بود",
	"افتاده شده است",
	"ورانداخته شده بود",
	"ویرایش شده است",
	"یافته شده است",
	"ستانده شده بود",
	"آراسته شده بود",
	"آزرده شدید",
	"آزموده شدید",
	"آشفته شدید",
	"آغشته شده بودند",
	"آفریده شده‌ای",
	"آلوده شده",
	"آمده است",
	"داشت آمیخته می‌شد",
	"داشت آورده می‌شد",
	"آویخته شده‌اند",
	"افتاده خواهد شد",
	"افراشته شده بود",
	"افروخته شده بود",
	"افزوده شده",
	"افشانده شده بود",
	"انباشته شده",
	"داشت انداخته می‌شد",
	"داشت اندوخته می‌شد",
	"برانگیخته شده بود",
	"بافته شده",
	"بخشوده شده‌اند",
	"بخشیده شده اند",
	"برده شده",
	"برگردانده شده‌اند",
	"داشت بسته می‌شد",
	"داشت پخته می‌شد",
	"پذیرفته شده",
	"داشت پراکنده می‌شد",
	"پرداخته شود",
	"پرسیده شده است",
	"داشت پژمرده می‌شد",
	"پسندیده شده بود",
	"پوشیده شده",
	"پیموده خواهد شد",
	"تافته شود",
	"تراشیده شده",
	"ترسانده شده است",
	"تکانده شده‌اند",
	"جوشانده شده بود",
	"جوشیده شده بود",
	"چاپیده شدید",
	"چرخیده شده بود",
	"چسبانده شده است",
	"چسبیده شده‌اند",
	"چشیده شده بود",
	"چیده شده",
	"خاسته شده بود",
	"خشکیده شده‌اند",
	"خراشیده شده بود",
	"خریده شده بودند",
	"خوانده شده",
	"داشت خورده می‌شد",
	"داده شده‌اند",
	"دزدیده شده است",
	"دوخته شده",
	"دوشیده شده",
	"رانده شده بود",
	"ربوده شده‌اند",
	"رسانده می‌شود",
	"رسیده خواهد شد",
	"ریخته شده بود",
	"زده شده بود",
	"زدوده خواهد شد",
	"ساخته شده",
	"سابیده شده",
	"ستانده شود",
	"ستوده می‌شود",
	"سوخته شده است",
	"سوزانده شده",
	"داشت انجام می‌شد",
	"داشت شسته می‌شد",
	"شکافته شده",
	"شکانده شده",
	"داشت شکسته می‌شد",
	"داشت شکفته می‌شد",
	"شمرده شده بود",
	"شناسانده خواهد شد",
	"شنفته شده است",
	"شنیده شده است",
	"طلبیده شدید",
	"فرساییده شده بود",
	"فرستاده شده بود",
	"فرسوده شده است",
	"داشت فروخته می‌شد",
	"دارد فشرده می‌شود",
	"کاسته شده است",
	"کاشته شود",
	"کشته شده‌اند",
	"کشیده شده است",
	"گفته بشود",
	"گذاشته شده بود",
	"گرفته شده بود",
	"گزیده شدیم",
	"گسسته خواهد شد",
	"گشوده شده بود",
	"گفته شده بود",
	"مالیده بشود",
	"نواخته شده است",
	"نوردیده بشود",
	"نوشته شده",
	"افتاده شده بود",
	"ورانداخته خواهد شد",
	"ویرایش شده‌اند",
	"یافته شده‌اند",
	"ستانده شود",
	"آراسته شود",
	"آزرده شدند",
	"آزموده شدند",
	"آشفته شدند",
	"آفریده شده",
	"آلوده شده است",
	"آمده‌اند",
	"داشتند آمیخته می‌شدند",
	"داشتند آورده می‌شدند",
	"آویخته شده بود",
	"افتاده خواهند شد",
	"افراشته بشود",
	"افروخته می‌شود",
	"افزوده شده است",
	"افشانده شده بودند",
	"انباشته شده است",
	"داشتند انداخته می‌شدند",
	"اندوخته شده",
	"برانگیخته شود",
	"بافته شده است",
	"بخشوده شود",
	"بخشیده شود",
	"برده شده است",
	"برگردانده شده بود",
	"داشتند بسته می‌شدند",
	"پخته شده",
	"پذیرفته شده است",
	"داشتند پراکنده می‌شدند",
	"پرداخته خواهد شد",
	"پرسیده شده‌اند",
	"داشتند پژمرده می‌شدند",
	"پسندیده شود",
	"پوشیده شده است",
	"پیموده بشود",
	"تافته بشود",
	"تراشیده شده است",
	"ترسانده شده‌اند",
	"دارد جوشانده می‌شود",
	"جوشیده شود",
	"چاپیده شدند",
	"چرخیده شده بودند",
	"چسبانده شده بود",
	"چسبیده شده بود",
	"چشیده شود",
	"چیده شده است",
	"خشکیده خواهد شد",
	"خراشیده شده بودند",
	"خریده خواهد شد",
	"خوانده شده است",
	"داشتند خورده می‌شدند",
	"داده شده بود",
	"دزدیده شده‌اند",
	"دوخته شده است",
	"دوشیده شده است",
	"رانده شده باشد",
	"ربوده شده بود",
	"رسانده خواهد شد",
	"رسیده شده باشد",
	"دارد ریخته می‌شود",
	"دارد زده می‌شود",
	"ساخته شده است",
	" سابیده شده است",
	"ستانده خواهد شد",
	"ستوده می‌شوند",
	"سوخته شده‌اند",
	"سوزانده شده است",
	"داشتند انجام می‌شدند",
	"داشتند شسته می‌شدند",
	"شکافته شده است",
	"شکانده شده است",
	"داشتند شکسته می‌شدند",
	"داشتند شکفته می‌شدند",
	"شمرده شده بودند",
	"شناسانده خواهند شد",
	"شنفته می‌شود",
	"شنیده شده بود",
	"طلبیده شدند",
	"فرساییده خواهد شد",
	"فرستاده خواهد شد",
	"فرسوده شده بود",
	"داشتند فروخته می‌شدند",
	"فشرده خواهد شد",
	"کاسته شده بود",
	"کاشته خواهد شد",
	"کشته شده بود",
	"کشیده شده بود",
	"گرفته می‌شود",
	"گزیده شدید",
	"گشوده شده بودند",
	"گفته شده باشد",
	"نواخته شده بود",
	"نوشته شده است",
	"افتاده شده بودند",
	"ورانداخته خواهند شد",
	"ویرایش شده بود",
	"یافته شده بود",
	"ستانده خواهد شد",
];

